import { Citation } from '#/api'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import ReactMarkdown from 'react-markdown'
import styles from './CitationPanel.module.css'

type CitationPanel = { citation: Citation }

export const CitationPanel = ({ citation }: CitationPanel) => {
  return (
    <ReactMarkdown
      linkTarget="_blank"
      className={styles.citationPanelContent}
      children={citation.content}
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
    />
  )
}
